export * from './src/teams.data';
export * from './src/simple.teams.display';